import { translateHerbTypeAbbr, HerbType } from "@model/models";

export const herbTypeAbbrFormatter = (herbType: HerbType) => {
    return translateHerbTypeAbbr(herbType);
}